// VESPER LUNA Product Carousel — vanilla custom element.
// Used by sections/product-carousel-banner.liquid.
// Desktop: transform-based slide nav. Mobile: native horizontal scroll (CSS).

class VlProductCarousel extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-vl-pc-viewport]');
    this.track = this.querySelector('[data-vl-pc-track]');
    this.prevBtn = this.querySelector('[data-vl-pc-prev]');
    this.nextBtn = this.querySelector('[data-vl-pc-next]');
    this.slides = [...this.querySelectorAll('.vl-pcb__slide')];

    if (!this.track || this.slides.length === 0) return;

    this.index = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.duration = parseInt(this.dataset.duration || '5', 10) * 1000;
    this.timer = null;

    this.prevBtn?.addEventListener('click', () => this._userGo(-1));
    this.nextBtn?.addEventListener('click', () => this._userGo(1));

    this.addEventListener('mouseenter', () => this._stopAutoplay());
    this.addEventListener('mouseleave', () => this._startAutoplay());

    this._resizeHandler = () => this._update();
    window.addEventListener('resize', this._resizeHandler, { passive: true });

    this._update();
    this._startAutoplay();
  }

  disconnectedCallback() {
    this._stopAutoplay();
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
  }

  _isMobile() {
    return window.matchMedia('(max-width: 760px)').matches;
  }

  _slidesPerView() {
    if (this._isMobile()) return parseInt(getComputedStyle(this).getPropertyValue('--cols-m') || '2', 10);
    return parseInt(getComputedStyle(this).getPropertyValue('--cols-d') || '4', 10);
  }

  _maxIndex() {
    const spv = this._slidesPerView();
    return Math.max(0, this.slides.length - spv);
  }

  _userGo(dir) {
    if (this._isMobile()) {
      // Mobile uses native scroll — emulate one product width
      const slide = this.slides[0];
      if (slide) {
        const w = slide.getBoundingClientRect().width + 10;
        this.viewport.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      return;
    }
    let next = this.index + dir;
    next = Math.max(0, Math.min(next, this._maxIndex()));
    this.index = next;
    this._update();
    this._stopAutoplay();
    this._startAutoplay();
  }

  _update() {
    if (this._isMobile()) {
      this.track.style.transform = '';
      return;
    }
    const max = this._maxIndex();
    if (this.index > max) this.index = max;
    const spv = this._slidesPerView();
    const slideW = 100 / spv;
    const offset = -slideW * this.index;
    this.track.style.transform = `translateX(${offset}%)`;

    if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.index === 0);
    if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.index >= max);
  }

  _startAutoplay() {
    if (!this.autoplay || this._isMobile() || this._maxIndex() === 0) return;
    this._stopAutoplay();
    this.timer = setInterval(() => {
      const max = this._maxIndex();
      this.index = (this.index >= max) ? 0 : this.index + 1;
      this._update();
    }, this.duration);
  }

  _stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('vl-product-carousel')) {
  customElements.define('vl-product-carousel', VlProductCarousel);
}
